'use client';
import {useEffect, useState} from 'react';

import {IExperienceDictionary} from '@/dictionaries/pages/experience/types';
import {ExperienceMedia} from '@/services/experienceTypes';

import GalleryModalCarousel from './GalleryModalCarousel';

type Props = {
  experienceMedia: ExperienceMedia[];
  dict: IExperienceDictionary;
  hasVideo?: boolean;
  hideTexts?: boolean;
  videoUrl: string | null;
  hasDarkBg?: boolean;
};

export default function GalleryModalImages({
  experienceMedia,
  dict,
  hasVideo = false,
  hideTexts = false,
  videoUrl,
  hasDarkBg = false,
}: Props) {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (openModal) {
      var root = document.getElementsByTagName('html')[0];
      document.body.classList.add('no-scroll');
      root.classList.add('no-scroll');
    } else {
      var root = document.getElementsByTagName('html')[0];
      document.body.classList.remove('no-scroll');
      root.classList.remove('no-scroll');
    }
  }, [openModal]);

  return (
    <>
      {openModal ? (
        <GalleryModalCarousel
          medias={experienceMedia}
          handleClose={() => setOpenModal(false)}
          hasVideo={hasVideo}
          videoUrl={videoUrl}
        />
      ) : (
        <div
          className={
            hasVideo
              ? `absolute top-0 flex items-center justify-center w-full h-full ${
                  hasDarkBg && 'bg-[rgba(0,0,0,.2)]'
                } cursor-pointer`
              : 'z-[1] absolute flex flex-col justify-end top-0 left-0 w-full h-full p-[30px] before:absolute before:bottom-0 before:left-0 before:w-full before:h-[100px] before:-z-[1] before:bg-exp-media cursor-pointer'
          }
          onClick={() => setOpenModal(true)}>
          {!hideTexts && (
            <div
              className={
                hasVideo ? 'flex flex-col justify-center gap-6' : 'flex'
              }>
              <h2 className="text-4xl text-white font-noe">
                {`${experienceMedia.length} ${dict.galleryPhotos}`}
              </h2>
              <button className={`${!hasVideo && 'ml-auto'} cursor-pointer`}>
                <span className="text-base text-white tracking-[2px] leading-[1.7] text-left font-averta-semibold uppercase">
                  {dict.galleryViewAll}
                </span>
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
